// extracted by mini-css-extract-plugin
export default {"container":"New_container__Ik8ei","logo":"New_logo__eyLTB","infos":"New_infos__k-F9U","star":"New_star__gMeQ0","is-favorite":"New_is-favorite__+F4Xl"};